import {Convert, HiikerElevation, hiikerElevationToLineStringFeature} from '../models/HiikerElevation'
import type { MarkerFeature } from '../models/MarkerFeature'
import { LineStringFeature } from '../models/LineStringFeature'
import pointsForLineString from "./PointOnStraightLineHelper";

export async function hiikerElevation(
  startMarker: MarkerFeature,
  endMarker: MarkerFeature
): Promise<LineStringFeature> {
  try {
    let points = pointsForLineString(startMarker.markerGeometry.coordinates[1], startMarker.markerGeometry.coordinates[0], endMarker.markerGeometry.coordinates[1], endMarker.markerGeometry.coordinates[0]);
    let coordsForElevationAPI = points.map((point) => {
      return [point[1], point[0]];
    })
    let raw = JSON.stringify(coordsForElevationAPI);
    const requestOptions = {
      method: 'POST',
      body: raw
    };

    let response = await fetch("https://elevation-service-2.hiiker.com", requestOptions)
    let json = await response.text()
    const hiikerElevation = Convert.toHiikerElevation(json);
    return hiikerElevationToLineStringFeature(hiikerElevation);
  } catch (error) {
    return LineStringFeature.straightLine(startMarker, endMarker);
  }
}

export async function getElevationData(
  coords: number[][]
): Promise<HiikerElevation[] | null> {
  try {
    // Some imports can be extremely long; chunk requests to avoid 413s
    const MAX_BATCH = 1000; // number of [lat, lng] points per request

    const results: HiikerElevation[] = [];
    for (let i = 0; i < coords.length; i += MAX_BATCH) {
      const batch = coords.slice(i, i + MAX_BATCH);
      const raw = JSON.stringify(batch);
      const requestOptions = { method: 'POST', body: raw } as RequestInit;

      const response = await fetch("https://elevation-service-2.hiiker.com", requestOptions);
      // On 413, retry with smaller chunks
      if (response.status === 413) {
        // Re-split this batch into smaller sub-batches
        const SMALL_BATCH = 200;
        for (let j = 0; j < batch.length; j += SMALL_BATCH) {
          const sub = batch.slice(j, j + SMALL_BATCH);
          const subRaw = JSON.stringify(sub);
          const subResp = await fetch("https://elevation-service-2.hiiker.com", { method: 'POST', body: subRaw });
          const subJson = await subResp.text();
          results.push(...Convert.toHiikerElevation(subJson));
        }
        continue;
      }

      const json = await response.text();
      results.push(...Convert.toHiikerElevation(json));
    }

    return results;
  } catch (error) {
    return null;
  }
}

export async function singleHiikerElevation(
  lat: number,
  lon: number
): Promise<HiikerElevation | null> {
  try {
    var raw = JSON.stringify([
      [
        lat,
        lon
      ]
    ]);
    const requestOptions = {
      method: 'POST',
      body: raw
    };
    let response = await fetch("https://elevation-service-2.hiiker.com", requestOptions)
    let json = await response.text()
    return  Convert.toHiikerElevation(json)[0];
  } catch (error) {
    return null
  }
}
